import { useQuery } from '@tanstack/react-query'
import { getERPClient } from '@/lib/erp/client'

export interface PaymentReminderStats {
  reminders_sent: number
  reminder_clicks: number
  reminder_conversions: number
  conversion_rate: number
}

export const PAYMENT_REMINDER_STATS_KEY = ['line-payment-reminder-stats'] as const

export function usePaymentReminderStats(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: PAYMENT_REMINDER_STATS_KEY,
    queryFn: async () => {
      const client = getERPClient()
      const result = await client.call(
        'zaviago_backend.storefront.line_payment_reminder.get_payment_reminder_stats',
        {}
      )
      return result as PaymentReminderStats
    },
    staleTime: 5 * 60 * 1000, // 5 min
    enabled: options?.enabled !== false,
  })
}
